import BidModel from 'models/BidModel';

BidsStore.dispatchToken = MakeShiftEmployeeDispatcher.register(BidsStore.dispatchCallback);

BidsStore.bids = [];

BidsStore.setBids = function (bids) {
  const len = bids.length;
  for (let i = 0; i < len; i++) {
    const bid = new BidModel(bids[i]);
    const { exchange_id } = bids[i];
    BidsStore.add(bid);
    // ExchangesStore.addAllBids(myBids);

    const exchange = ExchangesStore.get(exchange_id);
    if (!_.contains(exchange.attributes.bids, bid.attributes.id)) {
      exchange.attributes.bids.push(bid.attributes.id);
    }
  }
};

BidsStore.getBids = function (id) {
  let data = BidsStore.get(id);
  if (!Utils.isNotDefined(data)) {
    data = data.present();
  }
  return data;
};

BidsStore.getBidsByExchangeID = function (id) {
  const bids = [];
  const len = this.models.length;
  for (let i = 0; i < len; i++) {
    if (parseInt(this.models[i].attributes.exchange_id, 10) === parseInt(id, 10)) {
      const shift = ExchangesStore.getExchangeByShiftId(this.models[i].attributes.shift_id);
      const bid = this.models[i].clone();
      bid.attributes.shift_details = shift.shift_details;
      bids.push(bid.present());
    }
  }
  return bids;
};

BidsStore.onExchangeBidsHandler = function (collection, response, options) {
  const bidIDs = [];
  collection.bids.map((bid) => {
    if (!_.isUndefined(bid.id) && !_.contains(bidIDs, bid.id)) {
      bidIDs.push(bid.id);
    }
  });

  const exchange = ExchangesStore.getAdvertisementByExchangeID(options.exchange_id);
  if (!Utils.isNotDefined(exchange)) {
    exchange.bids = bidIDs;
  }

  const allExchange = ExchangesStore.getAllExchangeByID(options.exchange_id);
  if (!Utils.isNotDefined(allExchange)) {
    allExchange.bids = bidIDs;
  }

  const myBids = BidsStore.parseOutMyBids(collection.bids);
  BidsStore.add(myBids);
  ExchangesStore.addAllBids(myBids);
  BidsStore.trigger('exchanges:post:bids:success', BidsStore, collection);
};

BidsStore.onExchangeDropPickUpHandler = function (collection, response, options) {
  const bidIDs = [];
  collection.bids.map((bid) => {
    if (!_.isUndefined(bid.id) && !_.contains(bidIDs, bid.id)) {
      bidIDs.push(bid.id);
    }
  });

  const exchange = ExchangesStore.getAdvertisementByExchangeID(options.exchange_id);
  if (!Utils.isNotDefined(exchange)) {
    exchange.bids = bidIDs;
  }

  const allExchange = ExchangesStore.getAllExchangeByID(options.exchange_id);
  if (!Utils.isNotDefined(allExchange)) {
    allExchange.bids = bidIDs;
  }

  const myBids = BidsStore.parseOutMyBids(collection.bids);
  myBids.map((bid) => {
    bid.shift_id = options.shift_id;
  });
  BidsStore.add(myBids);
  ExchangesStore.addAllBids(myBids);
  BidsStore.trigger('exchanges:post:bid:drop:success', BidsStore, myBids[myBids.length - 1]);
};

BidsStore.onExchangeBidsError = function (collection, response) {
  BidsStore.trigger('exchanges:post:bids:error', collection, response);
};

BidsStore.parseOutMyBids = function (data) {
  const bids = [];
  if (typeof data === 'undefined') {
    return bids;
  }
  const len = data.length;
  for (let i = 0; i < len; i++) {
    const bid = data[i];
    if (!Utils.isNotDefined(bid) && bid.user_id === Utils.getCoreUser().id) {
      bids.push(bid);
      break;
    }
  }
  return bids;
};

BidsStore.iHazBidz = function (data) {
  let bool = false;
  if (typeof data === 'undefined') {
    return false;
  }
  const len = data.bids.length;
  for (let i = 0; i < len; i++) {
    const bid = BidsStore.getBids(data.bids[i]);
    if (!Utils.isNotDefined(bid) && bid.user_id === Utils.getCoreUser().id) {
      bool = true;
      break;
    }
  }
  if (!bool) {
    if (data.accepted_user_id === Utils.getCoreUser().id) {
      bool = true;
    }
  }
  return bool;
};

BidsStore.onDestroyBidSuccess = function (collection, response, options) {
  const allExchange = ExchangesStore.getAllExchangeByID(options.exchange_id);
  const { bids } = allExchange;
  const bidIDs = [];
  bids.map((bid) => {
    if (!_.isUndefined(bid.id) && !_.contains(bidIDs, bid.id)) {
      bidIDs.push(bid.id);
    }
  });

  const exchange = ExchangesStore.getAdvertisementByExchangeID(options.exchange_id);
  if (!Utils.isNotDefined(exchange)) {
    exchange.bids = bidIDs;
  }

  if (!Utils.isNotDefined(allExchange)) {
    allExchange.bids = bidIDs;
  }

  const myBids = BidsStore.parseOutMyBids(bidIDs);
  BidsStore.add(myBids);
  ExchangesStore.addAllBids(myBids);
  BidsStore.trigger('bids:destroy:success', ExchangesStore, collection);
};

BidsStore.onDestroyBidError = function (collection, response) {
  BidsStore.trigger('bids:destroy:error', BidsStore, response);
};
